import React from "react";
import { withStyles } from "@material-ui/styles";
import { includes } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import { sizes } from "../../constants/common";

const styles = {
  cardContainer: {
    padding: "8px",
    boxSizing: "border-box",
    //margin: "12px",
  },
  xsmallCard: {
    width: "250px",
  },
  smallCard: {
    width: "375px",
  },
  mediumCard: {
    width: "790px",
  },
  largeCard: {
    width: "908px",
  },
  xlargeCard: {
    width: "1572px",
  },
  cardTitle: {
    marginBottom: "10px",
    fontSize: "1.142em",
  },
};

const DashboardCard = (props) => {
  const { classes, title, topNode, size } = props;

  return (
    <Box
      className={clsx(
        "mainContent",
        classes.cardContainer
        // {
        //   [classes.xsmallCard]: size === sizes.xsmall,
        //   [classes.smallCard]: size === sizes.small,
        //   [classes.mediumCard]: size === sizes.medium,
        //   [classes.largeCard]: size === sizes.large,
        //   [classes.xlargeCard]: size === sizes.xlarge,
        // }
      )}
      id={props.id}
      style={{ width: !includes([sizes, size]) ? size : "", ...props.style }}
    >
      <Grid container direction="column" style={{ height: "100%" }}>
        {(title || topNode) && (
          <Grid item>
            <Grid container>
              {title && (
                <Grid
                  item
                  className={clsx("text-87", "bold-500", classes.cardTitle)}
                >
                  {title}
                </Grid>
              )}
              {topNode && <Grid item>{topNode}</Grid>}
            </Grid>
          </Grid>
        )}
        <Grid item xs style={{ position: "relative" }}>
          {props.children}
        </Grid>
      </Grid>
    </Box>
  );
};

export default withStyles(styles)(DashboardCard);
